module.exports = __webpack_public_path__ + "img/game-bg.50f4fc75.png";